import JSONbig from 'json-bigint'
import { API_BASE } from './config.js'

const jsonParser = JSONbig({ storeAsString: true })

function getToken() {
  return localStorage.getItem('token') || ''
}

function request(method, path, body) {
  const headers = {
    'Content-Type': 'application/json',
    'Authorization': 'Bearer ' + getToken()
  }
  const options = {
    method,
    headers,
    credentials: 'include'
  }
  if (body !== undefined) {
    options.body = JSON.stringify(body)
  }
  return fetch(`${API_BASE}${path}`, options)
    .then(res => res.text())
    .then(text => jsonParser.parse(text))
}

/**
 * 查询系统公开配置（匿名可调用，无需登录）
 *
 * 由后端 system_settings 表驱动，运维手写 SQL 修改后立即生效。
 * 前端首屏靠它决定：是否显示登录入口、是否显示注册入口、注册表单是否要邀请码输入框。
 *
 * @returns {Promise<{code:number,message:string,data:{loginEnabled:boolean,registerEnabled:boolean,inviteCodeRequired:boolean}|null,success:boolean}>}
 */
export function getPublicSettings() {
  return request('GET', '/api/v1/system/settings/public')
}

/**
 * 预校验邀请码（匿名可调用）
 *
 * 只校验不核销，不消耗邀请码次数 —— 真正的核销发生在注册接口内部。
 * 校验失败时 data 为 null，message 是具体原因（无效 / 已被禁用 / 已过期 / 已被使用 / 尚未生效）。
 *
 * @param {string} code 邀请码，大小写不敏感
 * @returns {Promise<{code:number,message:string,data:null,success:boolean}>}
 */
export function checkInviteCode(code) {
  return request('POST', '/api/v1/invite-codes/check', { code })
}
